/**
 *  @class
 *  @function DropHero
 *  Hides the drop hero's 'before the drop' content, or the whole section, when the drop opens.
 *  This also covers cached pages rendered before the drop opened, as the launch runs
 *  straight away when the drop time has already passed.
 */
if (!customElements.get('drop-hero')) {
	class DropHero extends HTMLElement {
		connectedCallback() {
			this.showNotifyResult();

			if (!this.dataset.timestamp) return;
			const msUntilDrop = parseInt(this.dataset.timestamp, 10) * 1000 - Date.now();
			// setTimeout fires immediately for delays over ~24.8 days, so leave those alone
			if (msUntilDrop > 2147483647) return;
			this.launchTimeout = setTimeout(() => this.launch(), Math.max(msUntilDrop, 0));
		}
		disconnectedCallback() {
			clearTimeout(this.launchTimeout);
		}
		launch() {
			if (this.hasAttribute('data-hide-after-drop')) {
				(this.closest('.shopify-section') || this).style.display = 'none';
				return;
			}
			this.classList.replace('drop-hero--locked', 'drop-hero--live');
		}
		/**
		 * Every customer form on the page shares form.posted_successfully? and form.errors, but
		 * Shopify adds the submitted form's id to the URL hash, so only reveal the result here
		 * when it was this form that was submitted.
		 */
		showNotifyResult() {
			const form = this.querySelector('.drop-hero__notify-form');
			if (!form || window.location.hash !== `#${form.id}`) return;

			const success = form.querySelector('[data-notify-result="success"]');
			const error = form.querySelector('[data-notify-result="error"]');
			if (success) {
				success.hidden = false;
				form.querySelector('.drop-hero__notify-fields').hidden = true;
			} else if (error) {
				error.hidden = false;
				const input = form.querySelector('.drop-hero__notify-input');
				if (input) {
					input.setAttribute('aria-invalid', 'true');
					input.setAttribute('aria-describedby', input.dataset.errorId);
				}
			}
		}
	}
	customElements.define('drop-hero', DropHero);
}
